import React from 'react';
import PropTypes from 'prop-types';
import TitleRow from '../TitleRow';
import FieldTriggerFlag from '../FieldTriggerFlag';

export default function TableFieldTitle({
  title,
  optional,
  fieldTrigger,
  isDisplay,
  sections,
  templateId,
  projectId,
  divisions,
  configProps,
  responding,
  onFieldTrigger,
}) {
  const fieldTriggerDisplay = fieldTrigger && !isDisplay;

  return (
    <TitleRow
      title={title}
      optional={optional}
      style={{ marginTop: 10 }}
      titleStyle={{ fontSize: 16 }}
      isFieldDisplay
      filter={fieldTriggerDisplay && (
        <FieldTriggerFlag
          sections={sections}
          templateId={templateId}
          projectId={projectId}
          divisions={divisions}
          configProps={configProps}
          responding={responding}
          onFieldTrigger={onFieldTrigger}
        />
      )}
    />
  );
}

TableFieldTitle.propTypes = {
  title: PropTypes.string.isRequired,
  optional: PropTypes.bool,
  fieldTrigger: PropTypes.bool,
  isDisplay: PropTypes.bool,
  sections: PropTypes.arrayOf(PropTypes.shape({})),
  templateId: PropTypes.string,
  projectId: PropTypes.string,
  divisions: PropTypes.arrayOf(PropTypes.string),
  configProps: PropTypes.object,
  responding: PropTypes.bool,
  onFieldTrigger: PropTypes.func,
};
